<script>
  import { auth, db } from "../etc/firebase.js"
  import { currentUser } from "../etc/store.js"
  import "materialize-css"
  // import { onMount } from "svelte"

  let email = ""
  let password = ""
  let showLoggedInElements = true

  document.addEventListener("DOMContentLoaded", function () {
    var modals = document.querySelectorAll(".modal")
    M.Modal.init(modals)

    // var items = document.querySelectorAll(".collapsible")
    // M.Collapsible.init(items)
  })

  // const loggedOutLinks = document.querySelectorAll(".logged-out")
  // const loggedInLinks = document.querySelectorAll(".logged-in")

  const setupUI = (user) => {
    if (user) {
      //console.log("Setting up Nav elements for " + user.email)
      showLoggedInElements = true
    } else {
      //console.log("Cleaning up Nav elements...")
      showLoggedInElements = false
    }
  }

  // Listen for auth status change
  auth.onAuthStateChanged((user) => {
    if (user) {
      //console.log(user.email + " just logged in!")
      setupUI(user)
      currentUser.email = user.email
      currentUser.loggedIn = true
    } else {
      //   notes = []
      //console.log(currentUser.email + " just logged out!")
      setupUI()
      currentUser.email = ""
      currentUser.loggedIn = false
    }
  })

  // signup
  function handleSignup() {
    //alert("doing signup with email and password: " + email + ", " + password)
    auth.createUserWithEmailAndPassword(email, password).then((credential) => {
      //console.log(credential.user)

      const modal_signup = document.querySelector("#modal-signup")
      M.Modal.getInstance(modal_signup).close()

      email = ""
      password = ""
      //  signupForm.reset()

      //alert("You account is created!")
    })
  }

  // login
  //const loginForm = document.querySelector("#login-form")
  function handleLogin() {
    //alert("doing signup with email and password: " + email + ", " + password)

    auth
      .signInWithEmailAndPassword(email, password)
      .then((credential) => {
        //console.log(credential.user)

        const modal_login = document.querySelector("#modal-login")
        M.Modal.getInstance(modal_login).close()

        //console.log("About to reset the login form")
        email = ""
        password = ""
        //loginForm.reset()

        //alert("You are logged in!")
      })
      .catch((error) => {
        alert("Account does not exist. Login for private use only.")
        const modal = document.querySelector("#modal-login")
        M.Modal.getInstance(modal).close()
      })
  }

  // logout
  //const logoutForm = document.querySelector("#logout")
  function handleLogout() {
    //alert("doing logout for email: " + email )
    auth.signOut()
    // auth.signOut().then(() => {
    //   //console.log("User Sign Out!")
    // })
    currentUser.email = ""
    currentUser.loggedIn = false
  }
</script>

<div class="navbar-fixed">
  <nav class="white" role="navigation">
    <div class="nav-wrapper container">
      <a href="/" class="brand-logo orange-text darken-4 ">Cloudidi</a>

      <ul id="nav-items" class="right hide-on-med-and-down">
        <li style="display: block;"><a href="/about">About</a></li>
        <li style="display: block;"><a href="/sandbox">Sandbox</a></li>
        <!-- <li><a href="/blog">Blog</a></li> -->
        <li
          class="logged-in"
          style="display: {showLoggedInElements ? 'block' : 'none'};"
        >
          <a href="/notes">Notes</a>
        </li>
        <!-- <li><a href="/news">News</a></li> -->
        <li
          class="logged-out"
          style="display: {showLoggedInElements ? 'block' : 'none'};"
        >
          <a href="/account" class="modal-trigger" data-target="modal-signup"
            >Signup</a
          >
        </li>
        <li
          class="logged-out"
          style="display: {showLoggedInElements ? 'none' : 'block'};"
        >
          <a href="/login" class=" modal-trigger" data-target="modal-login"
            >Login</a
          >
        </li>
        <li
          class="logged-in"
          style="display: {showLoggedInElements ? 'block' : 'none'};"
        >
          <a href="/account" class="">Account</a>
        </li>
        <li
          class="logged-in"
          style="display: {showLoggedInElements ? 'block' : 'none'};"
        >
          <a href="/" class="" id="logout" on:click={handleLogout}>Logout</a>
        </li>
      </ul>
    </div>
  </nav>
</div>

<!-- SIGN UP MODAL -->
<div id="modal-signup" class="modal">
  <div class="modal-content">
    <h4>Sign up</h4>
    <br />
    <form id="signup-form" on:submit|preventDefault={handleSignup}>
      <div class="input-field">
        <input
          type="email"
          id="signup-email"
          bind:value={email}
          autocomplete="section-blue email"
          required
        />
        <label for="signup-email">Email address</label>
      </div>
      <div class="input-field">
        <input
          type="password"
          id="signup-password"
          bind:value={password}
          autocomplete="section-blue current-password"
          required
        />
        <label for="signup-password">Choose password</label>
      </div>
      <button class="btn yellow darken-2 z-depth-0">Sign up</button>
    </form>
  </div>
</div>

<!-- LOGIN MODAL -->
<div id="modal-login" class="modal">
  <div class="modal-content">
    <h4>Login</h4>
    <br />
    <form id="login-form" on:submit|preventDefault={handleLogin}>
      <div class="input-field">
        <input type="email" id="login-email" bind:value={email} required />
        <label for="login-email">Email address</label>
      </div>
      <div class="input-field">
        <input
          type="password"
          id="login-password"
          bind:value={password}
          autocomplete="section-blue current-password"
          required
        />
        <label for="login-password">Your password</label>
      </div>
      <button class="btn yellow darken-2 z-depth-0">Login</button>
    </form>
  </div>
</div>

<!-- ACCOUNT MODAL -->
<div id="modal-account" class="modal">
  <div class="modal-content center-align">
    <h4>Account details</h4>
    <br />
    <div class="account-details" />
    <div class="account-extras" />
  </div>
</div>

<style>
  #nav-items a {
    color: #666666;
  }
</style>
